import { render, staticRenderFns } from "./mem_inside_tender.vue?vue&type=template&id=31bedd14&scoped=true&"
import script from "./mem_inside_tender.vue?vue&type=script&lang=js&"
export * from "./mem_inside_tender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bedd14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31bedd14')) {
      api.createRecord('31bedd14', component.options)
    } else {
      api.reload('31bedd14', component.options)
    }
    module.hot.accept("./mem_inside_tender.vue?vue&type=template&id=31bedd14&scoped=true&", function () {
      api.rerender('31bedd14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/body/addon/tender/mem_inside_tender.vue"
export default component.exports